import React from 'react';

import {
  Box,
  Text,
  Select,
  VStack,
  HStack,
  Badge,
  useColorModeValue,
  Spinner,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';

import { useTimezone } from 'contexts/TimezoneContext';
import { updateAppTimezoneApi } from 'features/app-settings/app-settings.api';

const TimezoneCard = () => {
  const {
    timezone,
    displayTime,
    timezoneOptions,
    loaded,
    saving,
    setTimezone,
  } = useTimezone();

  const bg = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const headingColor = useColorModeValue('gray.800', 'white');
  const mutedColor = useColorModeValue('gray.600', 'gray.400');

  const handleChange = async (event) => {
    const next = event.target.value;
    if (!next || next === timezone) return;
    const result = await setTimezone(next);
    if (updateAppTimezoneApi.fulfilled.match(result)) {
      toast.success('System timezone updated');
    } else {
      toast.error(result?.payload?.message || 'Could not update timezone');
    }
  };

  return (
    <Box
      bg={bg}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="xl"
      p={6}
      h="100%"
    >
      <VStack align="stretch" spacing={4}>
        <HStack justify="space-between" align="start">
          <Box>
            <Text fontSize="lg" fontWeight="bold" color={headingColor}>
              System timezone
            </Text>
            <Text fontSize="sm" color={mutedColor}>
              Dates, schedules, and cron jobs use this timezone across Sell Net.
            </Text>
          </Box>
          <Badge colorScheme="blue" variant="subtle">
            App-wide
          </Badge>
        </HStack>

        {!loaded ? (
          <HStack spacing={2} color={mutedColor}>
            <Spinner size="sm" />
            <Text fontSize="sm">Loading timezone…</Text>
          </HStack>
        ) : (
          <>
            <Box>
              <Text fontSize="xs" color={mutedColor} mb={1}>
                Current time
              </Text>
              <Text fontSize="md" fontWeight="semibold" color={headingColor}>
                {displayTime || '—'}
              </Text>
            </Box>

            <Box>
              <Text fontSize="xs" color={mutedColor} mb={1}>
                Timezone
              </Text>
              <Select
                value={timezone}
                onChange={handleChange}
                isDisabled={saving}
                size="sm"
              >
                {timezoneOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            </Box>
          </>
        )}
      </VStack>
    </Box>
  );
};

export default TimezoneCard;
